/* eslint-disable */
/// This file is auto generated - do not edit manually
export const ButtonText = 'Website.Product.VTO.ButtonText';
export const VirtualTryOn = 'Website.Product.VTO.VirtualTryOn';
export const VariantPrefix = 'Website.Product.VTO.VariantPrefix';
export const GoToProduct = 'Website.Product.VTO.GoToProduct';
export const LoadingError = 'Website.Product.VTO.LoadingError';
export const VariantError = 'Website.Product.VTO.VariantError';
